import { useEffect, useState, Fragment } from "react"
import Image from "next/image"
import { Tab, Transition } from "@headlessui/react"
import { classNames } from "core/utils"
import {
  ArrowDownIcon,
  ArrowLeftIcon,
  ChevronRightIcon,
  ChevronLeftIcon,
} from "@heroicons/react/20/solid"

export default function ImageGallery({ uniqueImages }: { uniqueImages?: any }) {
  const [selectedIndex, setSelectedIndex] = useState(0)
  const oneImage = uniqueImages?.length === 1
  const leftCarouselClick = () => {
    setSelectedIndex((selectedIndex - 1 + uniqueImages?.length) % uniqueImages?.length)
  }
  const rightCarouselClick = () => {
    setSelectedIndex((selectedIndex + 1 + uniqueImages?.length) % uniqueImages?.length)
  }

  useEffect(() => {
    setSelectedIndex(0)
  }, [uniqueImages])

  return (
    <Tab.Group
      as="div"
      className="relative w-full h-full overflow-hidden max-w-7xl mx-auto"
      selectedIndex={selectedIndex}
      // @ts-ignore
      onChange={setSelectedIndex}
    >
      {/* Image selector */}
      <Tab.List className="absolute text-center w-full z-10 inset-x-0 bottom-4 lg:bottom-28 flex space-x-1 justify-center">
        {uniqueImages?.map((image: any, index: number) => (
          <Tab as={Fragment} key={index}>
            {({ selected }) => (
              <span
                className={`rounded-md w-12 h-1 border border-solid border-transparent bg-white bg-clip-padding cursor-pointer transition-opacity duration-300 ease-linear ${
                  selected ? "opacity-100" : "opacity-30"
                }`}
              ></span>
            )}
          </Tab>
        ))}
      </Tab.List>

      <button
        onClick={leftCarouselClick}
        className={`absolute left-0 top-1/2 z-10 -translate-y-1/2 transform ${
          oneImage ? "hidden" : ""
        }`}
      >
        <ChevronLeftIcon className="h-12 w-12 text-white" aria-hidden="true" />
      </button>

      <Tab.Panels className="aspect-h-2 aspect-w-3 lg:aspect-none relative w-full h-full">
        {uniqueImages?.map((image: any, index: number) => (
          <Tab.Panel key={index}>
            <Image
              fill={true}
              src={image.src ?? "https://via.placeholder.com/1050x1050"}
              alt={image.alt}
              className="h-full w-full object-contain object-center absolute inset-0"
            />
          </Tab.Panel>
        ))}
      </Tab.Panels>
      <button
        onClick={rightCarouselClick}
        className={`absolute right-0 top-1/2 z-10 -translate-y-1/2 transform ${
          oneImage ? "hidden" : ""
        }`}
      >
        <ChevronRightIcon className="h-12 w-12 text-white" aria-hidden="true" />
      </button>
    </Tab.Group>
  )
}
